import React, { Component } from 'react';

import './styles.less';

class RedoButton extends Component {
  render() {
    const { currentTrimRange, redoStack } = this.props;

    const canRedo = currentTrimRange == null && redoStack.length > 0;

    if (!canRedo) {
      return null;
    }

    return (
      <div
        className="trim-bar-button trim-bar-redo-button enabled"
        onClick={this.props.onRedoTrim}
      >
        <span className="icon" />
        <span className="label">Redo</span>
      </div>
    );
  }
}

export default RedoButton;
